import { __rest } from "tslib";
import React, { useRef, useState, useCallback } from 'react';
import { LxEditorForSign } from './LxEditorForSign';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import style from './editor.module.scss';
const HOCEditModal = (Component) => {
    const EdModal = (props) => {
        const { ref, onEditCreated } = props, rest = __rest(props, ["ref", "onEditCreated"]);
        const [editorInstance, setEditorInstance] = useState(null);
        const [editVarShow, setEditVarShow] = useState(false);
        const [variableSelectedKey, setVariableSelectedKey] = useState('');
        const editVarRef = useRef();
        const editorSetup = ed => {
            setEditorInstance(ed);
            onEditCreated(ed);
            ed.on('showEditVar', data => {
                setEditVarShow(true);
                const timer = setInterval(() => {
                    var _a;
                    if (editVarRef.current) {
                        (_a = editVarRef.current) === null || _a === void 0 ? void 0 : _a.insertContent(data.varContent);
                        clearInterval(timer);
                    }
                }, 500);
                setVariableSelectedKey(data.varId);
            });
        };
        const EditVarModal = useCallback(() => {
            const confirmEdit = () => {
                var _a, _b;
                const varContent = (_a = editVarRef.current) === null || _a === void 0 ? void 0 : _a.getContent();
                const varText = (_b = editorInstance === null || editorInstance === void 0 ? void 0 : editorInstance.getBody()) === null || _b === void 0 ? void 0 : _b.querySelector(`[varid="${variableSelectedKey}"] .varText`);
                if (varText) {
                    varText.innerHTML = varContent;
                }
                setEditVarShow(false);
            };
            const insertProductName = () => {
                var _a;
                (_a = editVarRef.current) === null || _a === void 0 ? void 0 : _a.insertContent('<span class="mce-lx-var mceNonEditable varSpan" contenteditable="false" data-var="#{wmt_event_recent_product_name_en}" data-var-show="[收件人最近查看的商品英文名称]">[收件人最近查看的商品英文名称]</span>');
            };
            return (React.createElement(SiriusModal, { visible: editVarShow, width: 930, title: "\u7F16\u8F91\u53D8\u91CF", className: style.editModal, getContainer: "body", onCancel: () => {
                    setEditVarShow(false);
                }, destroyOnClose: false, onOk: confirmEdit },
                React.createElement(React.Fragment, null,
                    React.createElement(LxEditorForSign, { uniqueClass: "interactvar-editor", init: {
                            setup: ed => {
                                editVarRef.current = ed;
                            },
                            plugins: [
                                'advlist autolink lists  print preview fullpage paste',
                                'searchreplace visualblocks fullscreen nonbreaking lxsignature',
                                'lxmailformat lxformatpainter wordcount',
                            ],
                            selector: 'textarea',
                            toolbar_mode: 'wrap',
                            toolbar: `undo redo lxformatpainter removeformat $split fontselect fontsizeselect bold italic underline forecolor 
                backcolor $split bullist numlist $split alignleftSplit dentSplit lineheight`,
                        } }),
                    variableSelectedKey === 'event-product-click-var-content' && (React.createElement("div", { className: style.addProductVar, onClick: insertProductName }, "+ \u5546\u54C1\u53D8\u91CF")))));
        }, [editVarShow, variableSelectedKey]);
        return (React.createElement(React.Fragment, null,
            React.createElement(EditVarModal, null),
            React.createElement(Component, Object.assign({}, rest, { ref: ref, onEditCreated: editorSetup }))));
    };
    return React.forwardRef((props, ref) => React.createElement(EdModal, Object.assign({}, props, { ref: ref })));
};
export default HOCEditModal;
